import React from "react";
import styled from "styled-components";
import Layout from "../components/layout";
import { Main } from "../styled/Main";



export default function Home() {
  return (
    <Layout>
      <h3>Hey, I'm Craig!</h3>
      <img src="https://res.cloudinary.com/dm9ig1vtk/image/upload/v1643915636/Portfolio/20210112_205301-removebg-preview_lwyszl.png" />
      <p>I'm a full-stack developer committed to building intuitive, performative and beautiful web applications. In my free time I enjoy hiking, exploring and playing Ultimate.</p>
    </Layout>
  );
}

<style>

</style>